import logging from 'utils/logging';
import { GAMESTATE_INSTRUCTIONS } from '../../gamestate/constants';
import { NARRATION_KEYS, MOMENT_TYPES } from '../hostStateSlice';

const log = logging.getLogger('instructions-moment');
log.setLevel('info');

export const InstructionsMoment = {
  id: 'instructions_screen',
  shouldTrigger: ({ prevState, currentState }) => {
    if (!prevState) {
      return false;
    }
    if (currentState.currentState === GAMESTATE_INSTRUCTIONS &&
      prevState.currentState !== GAMESTATE_INSTRUCTIONS) {
        return {
          shouldTriggerAction: false,
          shouldGenerateNarration: true,
          narrationParams: {
            narrationKey: NARRATION_KEYS.INSTRUCTIONS,
            momentType: MOMENT_TYPES.INSTRUCTIONS
          }
        };
      }
    return false;
  }
}


export const InstructionsPlaybackMoment = {
  id: 'instructions_screen_playback',
  narrationKey: NARRATION_KEYS.INSTRUCTIONS,
  momentType: MOMENT_TYPES.INSTRUCTIONS,
  shouldPlay: (gameState, hostState, narration, playedNarrations) => {

    log.debug('Checking if InstructionsPlaybackMoment should play', gameState, hostState, narration, playedNarrations);
    if (playedNarrations.has(narration.key)) {
      log.debug('Narration has already been played, skipping');
      return false;
    }

    if (gameState.currentState !== GAMESTATE_INSTRUCTIONS) {
      return false;
    }

    if (narration.momentType !== MOMENT_TYPES.INSTRUCTIONS) {
      return false;
    }

    if (narration.textStatus !== 'READY' || (narration.audioStatus !== 'READY' && narration.audioStatus !== 'ERROR')) {
      return false;
    }

    return true;
  }
}

const api = {
  trigger: InstructionsMoment,
  playback: InstructionsPlaybackMoment
};

export default api;
